import React from 'react';
import './LoginHero.css';

const LoginHero = () => {
  return (
    <section className="login-hero">
      <div className="container">
        <div className="login-hero-content">
          <h1 className="login-title">
            Login to your account
          </h1>
          <p className="login-subtitle">
            If you are already registered, login here
          </p>
        </div>
      </div>
    </section>
  );
};

export default LoginHero;
